
































import { Component, Prop, Vue } from "@/shared/vuepack";
import {
  HsabExpenseDisplayStatus,
  HsabExpenseEvidenceShoeboxModalSource,
  HsabExpenseOriginator,
  HsabExpenseReimbursementResponse,
  HsabSsoDestination,
  WexExpenseAccountType
} from "@/shared/types";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import Pill from "@/shared/components/ui/Pill.vue";
import HsabExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidence.vue";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import HsabExpenseEvidenceShoeboxModal
  from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidenceShoeboxModal.vue";
import { useHsabExpenseEvidenceShoeboxStore } from "@/employee/store/hsabExpenseEvidenceShoebox";

@Component({
  computed: {
    HsabSsoDestination () {
      return HsabSsoDestination;
    }
  },
  components: {
    HsabExpenseEvidenceShoeboxModal,
    GenericLoadingSpinner,
    SsoDeepLink,
    HsabExpenseEvidence,
    Pill,
    CurrencyAmount
  }
})
export default class HsabExpenseCardRowExpenseEvidence extends Vue {

  @Prop()
  stagedFilesForUpload;

  @Prop({ default: false })
  isUploadingFilesToSubmittedExpense: boolean;

  @Prop({ default: false })
  forceReadOnly: boolean;

  managedExpenseStore = useManagedExpenseStore();
  hsabAccountsStore = useHsabAccountsStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  hsabExpenseEvidenceShoeboxStore = useHsabExpenseEvidenceShoeboxStore();

  get expense () {
    return this.hsabExpenseFormStore.expense;
  }
  created () {
    this.hsabAccountsStore.getHsabAccounts();
    this.managedExpenseStore.loadUserHasHealthPlanExpense();
  }

  get uploadFileCount () {
    let count = 0;
    if (this.expense && this.expense.expenseEvidence) {
      count += this.expense.expenseEvidence.length;
    }
    if (this.stagedFilesForUpload) {
      count += this.stagedFilesForUpload.length;
    }
    return count;
  }

  get isExpenseSubmitted (): boolean {
    return this.hsabExpenseFormStore.hasExpense && this.expense.isSubmitted;
  }

  get isExpenseSubmittedToHsa (): boolean {
    return this.hsabExpenseFormStore.hasExpense &&
        this.expense.isSubmitted &&
        this.expense.reimbursement &&
        this.expense.reimbursement.isHsaReimbursement;
  }

  get isAddingReceiptsAllowed () {
    if (this.forceReadOnly) {
      return false;
    }

    if (!this.expense) {
      return true;
    }
    return this.expense.isFileUploadAllowed;
  }

  get isDeletingReceiptsAllowed (): boolean {
    return this.isHsaOnly || this.isExpenseSubmittedToHsa || !this.isExpenseSubmitted;
  }

  get isHsaOnly () {
    const userHasHsa = this.hsabAccountsStore.userHasHsaAccount;
    const userHasNotional = this.hsabAccountsStore.userHasActiveNotionalAccounts;
    return (!userHasNotional && userHasHsa);
  }

  get showButtonForReceiptNeeded () {
    return this.expense &&
        (this.expense.originator === HsabExpenseOriginator.DebitCard || this.expense.originator === HsabExpenseOriginator.Disbursement) &&
        this.expense.reimbursement &&
        this.expense.reimbursement.displayStatus === HsabExpenseDisplayStatus.ReceiptNeeded &&
        this.managedExpenseStore.userHasHealthPlanExpense &&
        this.hsabAccountsStore.userHasActiveNotionalAccounts;
  }

  get shoeboxModalSource (): HsabExpenseEvidenceShoeboxModalSource {
    return HsabExpenseEvidenceShoeboxModalSource.cardRowExpenseEvidence;
  }

  get showShoeboxModal (): boolean {
    return this.hsabExpenseEvidenceShoeboxStore.isModalOpen &&
        this.hsabExpenseEvidenceShoeboxStore.modalOpenedBy === HsabExpenseEvidenceShoeboxModalSource.cardRowExpenseEvidence;
  }

  get showSubmitButton (): boolean {
    return (this.stagedFilesForUpload && this.stagedFilesForUpload.length >= 1)
        || this.hsabExpenseFormStore.hasShoeboxEvidenceAttached;
  }

  addFiles (files) {
    this.$emit("staged-files-updated", files);
  }

  handleAddFilesAfterSubmitted () {
    this.$emit("stage-files-submitted");
  }

}
